/**
 * This utility function can be used to retrieve the value of a css property that belongs to a certain element.
 * The default element is the document.documentElement, where if we passed a certain css variable that was defined under the :root its value will be retrieved
 * usage example:
 * getElementStyleProperty('--global-css-var') // if css var was defined under root we will get its value.
 * or we can pass the element so we can get the css properties and variables that are scoped under this element:
 * getElementStyleProperty('--el-css-var', el)
 * @returns {string}
 */
const getElementStyleProperty = (property, el = document.documentElement) => {
    return getComputedStyle(el).getPropertyValue(property);
};

export default getElementStyleProperty;
